import * as Definitions from "./Definitions";
import { Observable } from "rxjs";
import { Effects } from "../";
export const description = "";
export const method = "POST";
export const operationId = "workwearExpressCustomerServiceLoginAuthServiceV1LoginPost";
export const path = "/V1/customer-service/login";
export interface Body {
    username: string;
    password: string;
}
export type Response = Response200 | ResponseDefault;
export type Response200 = Definitions.WorkwearExpressCustomerServiceLoginDataAuthResponseInterface;
export type RespKeys = (keyof Definitions.WorkwearExpressCustomerServiceLoginDataAuthResponseInterface)[];
export type ResponseDefault = Definitions.ErrorResponse;
type MinimalEffects = Pick<Effects, "apiUrl" | "restHeaders" | "postJSON">;
export function execute<T extends RespKeys | undefined>(body: Body, effects: MinimalEffects, fields?: T): T extends RespKeys ? Observable<Pick<Definitions.WorkwearExpressCustomerServiceLoginDataAuthResponseInterface, T[number]>> : Observable<Response200> {
    return effects.postJSON(effects.apiUrl(operationId)(path, undefined, fields), body, effects.restHeaders({})) as any;
}
